import { render, staticRenderFns } from "./Fornecedor.vue?vue&type=template&id=399d6108"
import script from "./Fornecedor.vue?vue&type=script&lang=js"
export * from "./Fornecedor.vue?vue&type=script&lang=js"
import style0 from "./Fornecedor.vue?vue&type=style&index=0&id=399d6108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports